import { useContext } from 'react';
import { WizardContext } from './wizardContext';

const useWizard = () => {
  const wizardValue = useContext(WizardContext);
  return wizardValue;
};

export default useWizard;
